export class Province {
    _id = '';
    name = '';
    accounts = [];    
   
  }


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_models/province.ts